import { __decorate, __metadata } from "tslib";
import { BaseService, HTTP_METHOD, Method, restParamMapper, Service, STATUS, } from '@cbbt/lib-interface';
import { OCISIndividualRecordLimitExceededError } from './errors/OCISIndividualRecordLimitExceededError.js';
import { SearchIndividualsRequest } from './models/individuals/SearchIndividualsRequest.js';
import { SearchIndividualsResponse } from './models/individuals/SearchIndividualsResponse.js';
let SearchIndividualService = class SearchIndividualService extends BaseService {
    searchIndividuals(_transport, request) {
        return this.unimplemented(request);
    }
};
__decorate([
    Method({
        summary: 'search individual record',
        description: 'search individual records from ocis database',
        successStatus: STATUS.OK,
        throws: [OCISIndividualRecordLimitExceededError],
    }),
    Method.rest({
        method: HTTP_METHOD.GET,
        path: '/',
        params: [
            restParamMapper.query({ from: 'lastName', to: 'lastName' }),
            restParamMapper.query({ from: 'foreName', to: 'foreName' }),
            restParamMapper.query({ from: 'postCode', to: 'postCode' }),
            restParamMapper.query({ from: 'birthDate', to: 'birthDate' }),
        ],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, SearchIndividualsRequest]),
    __metadata("design:returntype", SearchIndividualsResponse)
], SearchIndividualService.prototype, "searchIndividuals", null);
SearchIndividualService = __decorate([
    Service({
        description: 'This is an individual service for BCB onboarding',
    }),
    Service.rest({
        basePath: '/searchIndividuals',
    })
], SearchIndividualService);
export { SearchIndividualService };
//# sourceMappingURL=SearchIndividualService.js.map